'use client'
import React, { useEffect, useState, useRef, useCallback } from 'react'
import Modal from '@/components/Modal'
import { Button } from 'antd'
import styles from './page.module.scss'
import Image from 'next/image'
import { useLocale } from 'core/components/Locale'
import QRCode from 'qrcode'
import { useSetWalletInfo } from 'core/controller/web3/walletStore'
import {
  useGetWeb3WalletGenerateQrcodeQuery,
  useGetWeb3WalletScanLoginQuery,
} from 'core/query/yapi/hk-web/Web3Wallet/query'
import { useHCRouter } from '@/components/HCNextLink'

interface ConnectWalletProps {
  visible: boolean
  onCancel: () => void
}

const ConnectWalletModal: React.FC<ConnectWalletProps> = ({ visible, onCancel }) => {
  const t = useLocale()
  const router = useHCRouter()
  const setWalletInfo = useSetWalletInfo()
  const { data: loginQrCodeData, refetch } = useGetWeb3WalletGenerateQrcodeQuery()
  const {
    data: scanLoginData,
    error: scanLoginError,
    refetch: refetchScanLogin,
  } = useGetWeb3WalletScanLoginQuery({ qrCodeToken: loginQrCodeData?.data?.data?.qrCodeToken }, { enabled: false })
  const [isScanLogin, setIsScanLogin] = useState(false)
  const [isQRCodeInvalid, setIsQRCodeInvalid] = useState(false)
  const [qrRCode, setQrRCode] = useState<string>('')
  const intervalRef = useRef<NodeJS.Timeout>()
  const timeoutRef = useRef<NodeJS.Timeout>()
  useEffect(() => {
    if (loginQrCodeData?.data?.data) {
      const qrCodeToken = loginQrCodeData?.data?.data?.qrCodeToken
      QRCode.toDataURL(document.createElement('canvas'), qrCodeToken, { margin: 1 }).then((res) => {
        setQrRCode(res)
        setIsScanLogin(true)
      })
    }
  }, [loginQrCodeData])
  const clearTimer = useCallback(() => {
    clearTimeout(timeoutRef.current)
    clearInterval(intervalRef.current)
  }, [])
  const getIsScanLogin = useCallback(
    (token?: string) => {
      if (!token) return
      refetchScanLogin()
    },
    [refetchScanLogin]
  )
  useEffect(() => {
    if (scanLoginError) {
      if (scanLoginError.data && scanLoginError.data.code === 10029) {
        setIsQRCodeInvalid(true)
        clearTimer()
      }
    }
    if (scanLoginData?.data.code === 200) {
      // 处理扫码成功的逻辑
      setWalletInfo(scanLoginData?.data.data)
      onCancel()
      // 跳转资产页
      router.push('/web3/asset')
    }
  }, [scanLoginData, scanLoginError, clearTimer])
  const resetQRCode = useCallback(() => {
    clearTimer()
    setIsQRCodeInvalid(false)
    refetch().then(({ data: qrCodeData }) => {
      timeoutRef.current = setTimeout(() => {
        getIsScanLogin(qrCodeData?.data?.data?.qrCodeToken)
        intervalRef.current = setInterval(() => {
          getIsScanLogin(qrCodeData?.data?.data?.qrCodeToken)
        }, 30000)
      }, 2000)
    })
  }, [clearTimer, getIsScanLogin, refetch])

  useEffect(() => {
    if (isScanLogin) {
      resetQRCode()
    } else {
      clearTimer()
    }
    return clearTimer
  }, [isScanLogin, resetQRCode, clearTimer])
  const download = () => {
    window.open('https://www.hotcoin.cc/zh_CN/app/downLoad/')
  }
  return (
    <>
      <Modal
        title={t('hotcoinWeb_v1_12_2128889_ConnectHotcoinWallet')}
        className={styles.connect_wallet_modal}
        closeOnMaskClick={false}
        open={visible}
        width={400}
        onClose={onCancel}
      >
        <div className={styles.connect_wallet_content}>
          <div className={styles.text}>{t('hotcoinWeb_v1_12_2128889_PleaseOpenTheHotcoin')}</div>
          <div className={styles.imgDiv}>
            <Image className={styles.image} alt="image" width={135} height={135} unoptimized src={qrRCode} />
            {isQRCodeInvalid && (
              <div className={styles.refresh}>
                <div className={styles.btn} onClick={resetQRCode}>
                  {t('111_v1_2223_Refresh')}
                </div>
              </div>
            )}
          </div>
          <div className={styles.download}>
            {t('hotcoinWeb_v1_12_2128889_HaventDownloadedYetClickTo', {
              link_0: {
                tag: 'a',
                props: {
                  onClick: download,
                  className: styles.btn,
                },
              },
            })}
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ConnectWalletModal
